export default "__VITE_ASSET__DgDa6uWu__"